module.exports = __webpack_public_path__ + "static/img/dxxkz.81c658d1.jpg";